import * as React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import InputTooltip from '../Tooltips/InputTooltip';
import { SvgIconComponent } from '@material-ui/icons';

interface Props
  extends Omit<TextFieldProps, 'variant' | 'margin' | 'ref' | 'inputRef' | 'size' | 'InputProps'> {
  tooltip?: NonNullable<React.ReactNode>;
  adornmentIcon?: React.ReactElement<SvgIconComponent>;
  readOnly?: boolean;
}

const SelectInput = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLInputElement>): React.ReactElement => {
    const { adornmentIcon, tooltip, readOnly = false, ...rest } = props;

    return (
      <TextField
        id={props.id ?? props.name}
        fullWidth
        {...rest}
        inputRef={ref}
        variant="outlined"
        margin="normal"
        size="small"
        select
        SelectProps={{
          native: true,
        }}
        InputProps={{
          startAdornment:
            tooltip && adornmentIcon ? (
              <InputTooltip title={tooltip}>{adornmentIcon}</InputTooltip>
            ) : tooltip && !adornmentIcon ? (
              <InputTooltip title={tooltip} />
            ) : undefined,
          readOnly: readOnly,
        }}
        InputLabelProps={{ shrink: true }}
      />
    );
  }
);

export default SelectInput;
